import { serviceBellDataUrl } from './serviceBellData'

export type NotificationTone='order'|'urgent'|'payment'|'success'|'notice'

const key=(scope:string)=>`goncalo_sound_${scope}`

export function getSoundEnabled(scope='staff'){
  if(typeof window==='undefined')return false
  return window.localStorage.getItem(key(scope))==='on'
}

export function setSoundEnabled(enabled:boolean,scope='staff'){
  if(typeof window==='undefined')return
  window.localStorage.setItem(key(scope),enabled?'on':'off')
  window.dispatchEvent(new CustomEvent('goncalo:sound-setting',{detail:{scope,enabled}}))
}

function fallbackBell(){
  const AudioCtx=window.AudioContext||((window as typeof window & {webkitAudioContext?:typeof AudioContext}).webkitAudioContext)
  if(!AudioCtx)return
  try{
    const ctx=new AudioCtx()
    const oscillator=ctx.createOscillator()
    const gain=ctx.createGain()
    oscillator.type='sine'
    oscillator.frequency.setValueAtTime(1180,ctx.currentTime)
    gain.gain.setValueAtTime(.0001,ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(.45,ctx.currentTime+.01)
    gain.gain.exponentialRampToValueAtTime(.0001,ctx.currentTime+.7)
    oscillator.connect(gain);gain.connect(ctx.destination)
    oscillator.start();oscillator.stop(ctx.currentTime+.72)
    window.setTimeout(()=>void ctx.close(),900)
  }catch{/* navegador sem áudio liberado */}
}

function ringOnce(){
  try{
    const audio=new Audio(serviceBellDataUrl)
    audio.volume=1
    audio.preload='auto'
    const play=audio.play()
    if(play)void play.catch(()=>fallbackBell())
  }catch{fallbackBell()}
}

export function playNotificationSound(tone:NotificationTone='notice',scope='staff'){
  if(typeof window==='undefined'||!getSoundEnabled(scope))return
  const patterns:Record<NotificationTone,number[]>={
    order:[0,850],
    urgent:[0,780,1560],
    payment:[0,900],
    success:[0],
    notice:[0,950],
  }
  for(const delay of patterns[tone])window.setTimeout(ringOnce,delay)
}
